import createIcon from '../../createIcon';

/**
 * @component @name TaskAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgNS4xOEwxMC41OSAxNi42TDYuMzUgMTIuMzZMNy43NiAxMC45NUwxMC41OSAxMy43OEwyMC41OSAzLjc4TDIyIDUuMThaTTE5Ljc5IDEwLjIyQzE5LjkyIDEwLjc5IDIwIDExLjM5IDIwIDEyQzIwIDE2LjQyIDE2LjQyIDIwIDEyIDIwQzcuNTggMjAgNCAxNi40MiA0IDEyQzQgNy41OCA3LjU4IDQgMTIgNEMxMy41OCA0IDE1LjA0IDQuNDYgMTYuMjggNS4yNUwxNy43MiAzLjgxQzE2LjEgMi42NyAxNC4xMyAyIDEyIDJDNi40OCAyIDIgNi40OCAyIDEyQzIgMTcuNTIgNi40OCAyMiAxMiAyMkMxNy41MiAyMiAyMiAxNy41MiAyMiAxMkMyMiAxMC44MSAyMS43OCA5LjY3IDIxLjQgOC42MUwxOS43OSAxMC4yMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TaskAlt = createIcon('TaskAlt', [
  [
    'path',
    {
      d: 'M22 5.18L10.59 16.6L6.35 12.36L7.76 10.95L10.59 13.78L20.59 3.78L22 5.18ZM19.79 10.22C19.92 10.79 20 11.39 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C13.58 4 15.04 4.46 16.28 5.25L17.72 3.81C16.1 2.67 14.13 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 10.81 21.78 9.67 21.4 8.61L19.79 10.22Z',
      key: '1qvh86',
    },
  ],
]);

export default TaskAlt;
